export default "__VITE_ASSET__8CYPB4pQ__"